<script>
import {userMixin} from "@/mixin";
import {email, maxLength, minLength, numeric, required, requiredIf, sameAs} from "vuelidate/lib/validators";
import profileForm from "@/components/app/profile/profileInfoForms/mixin/profileForm";

export default {
    name: "personalRecipientForm",
    mixins: [userMixin, profileForm],
    validations: {
        user: {
            recipientName: {required, minLength: minLength(2)},
            recipientCode: {required, minLength: minLength(8), maxLength: maxLength(10)},
            recipientAccount: {required, minLength: minLength(2)},
            recipientBankName: {required, minLength: minLength(2), maxLength: maxLength(190)},
            recipientBankCard: {
                required: requiredIf(function (nestedModel) {
                    return this.user.recipientTypeId == 0
                }),
                minLength: minLength(10),
                maxLength: maxLength(19)
            },
        }
    },
}
</script>

<template>
    <div class="user-section">
        <div class="row">
            <div class="col-12 user-section-header">
                <h4 class="text-left font-weight-bold">Реквізити рахунку:</h4>
                <hr/>
            </div>


            <div class="col-lg-4" v-if="user && !user.parentId">
                <div class="form-group">
                    <div class="field-label">Періодичність виведення КВ</div>
                    <el-select v-if="!skeletonOff && !user.parentId" v-model="user.periodActsGenerateId" placeholder="Періодичність виведення КВ" class="w-100">
                        <el-option
                            v-for="item in periodActsGenerate"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <PuSkeleton class="skeleton-input" v-else/>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Найменування отримувача</div>
                    <input v-if="!skeletonOff" v-model.trim="user.recipientName" type="text"
                           placeholder="Найменування отримувача" class="form-control"
                           :class="['form-control', {invalid: ($v.user.recipientName.$error)}]"
                    >
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.recipientName.$dirty && !$v.user.recipientName.minLength">Введіть імʼя особи отримувача</small>
                    <small class="error" v-if="$v.user.recipientName.$dirty && !$v.user.recipientName.required">Введіть імʼя особи отримувача</small>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Код отримувача</div>
                    <input v-if="!skeletonOff" v-mask="'##########'" v-model.trim="user.recipientCode" type="text"
                           placeholder="Код отримувача" class="form-control"
                           :class="['form-control', {invalid: ($v.user.recipientCode.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.recipientCode.$dirty && !$v.user.recipientCode.minLength">Введіть код отримувача</small>
                    <small class="error" v-if="$v.user.recipientCode.$dirty && !$v.user.recipientCode.required">Введіть код отримувача</small>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Рахунок отримувача</div>
                    <input v-if="!skeletonOff" v-model.trim="user.recipientAccount" type="text"
                           placeholder="Рахунок отримувача" class="form-control"
                           :class="['form-control', {invalid: ($v.user.recipientAccount.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.recipientAccount.$dirty && !$v.user.recipientAccount.minLength">Введіть номер рахунку отримувача</small>
                    <small class="error" v-if="$v.user.recipientAccount.$dirty && !$v.user.recipientAccount.required">Введіть номер рахунку отримувача</small>
                </div>
            </div>

            <div v-if="isRecipientFizType() || isRecipientFizReferalType()" class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Номер картки</div>
                    <input v-if="!skeletonOff" v-mask="'#### #### #### ####'" v-model.trim="user.recipientBankCard" type="text"
                           placeholder="Номер картки" class="form-control"
                           :class="['form-control', {invalid: ($v.user.recipientBankCard.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.recipientBankCard.$dirty && !$v.user.recipientBankCard.minLength">Введіть номер картки отримувача</small>
                    <small class="error" v-if="$v.user.recipientBankCard.$dirty && !$v.user.recipientBankCard.required">Введіть номер картки отримувача</small>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Банк отримувача</div>
                    <input v-if="!skeletonOff" v-model.trim="user.recipientBankName" type="text"
                           placeholder="Назва банку" class="form-control"
                           :class="['form-control', {invalid: ($v.user.recipientBankName.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.recipientBankName.$dirty && !$v.user.recipientBankName.minLength">Введіть назву банку отримувача</small>
                    <small class="error" v-if="$v.user.recipientBankName.$dirty && !$v.user.recipientBankName.required">Введіть назву банку отримувача</small>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>
